import Core from './Core'

export { default as models } from './utils/models'
export * from './utils/getters'

export default new Core()
